import  React, {
        useState, 
        useEffect, 
        useRef, 
        useMemo, 
        useCallback
        }                                   from "react";
import  {useLoader}                         from "components/Covers/loadingCover";
import  Style                               from "components/UI/main.module.scss";
import  {   getUserList,
            getUserBindByID,
            updateUserBind, 
            getUserInDepartmentList          
        }                                   from "./bindUsersService";
import  {   GetSystemLabel,
            GetBusinessLabel,
            GetAppLang,
            Spinner,
            SpinnerSmall,
            sleep,
            ValidateBusinessRules
        }                                   from "Utilities/utils";   
import  {
            DisplayGridDatetime
        }                                   from "components/Date/date";
import { useModal }                         from "components/Covers/genericModal";
import { useToastMessage}                   from "components/Covers/toastMessage";
import { useSideContent }                   from "components/SideContent/sideContent";
import { ModalContent,
       }                                    from "components/Modal/modal";
import { TableGrid}                         from "components/Table/table";
import { SearchableDropdownList}            from "components/DropdownListField/dropdownListFIeld";
import  {   StatusFilter}                   from "components/Filter/statusFilter";
import  {   NeedSaveBlock}                  from "components/Validation/needSaveBlock";
import  {   LabelModule,
            IconHistory,
        }                                   from "components/Label/label";
import  {   getSystemStatusList}            from "Services/service";
import { AccessDeniedContent } from "components/Content/accessContent";

const blank_user_obj            = {
    NeedSave   :    false, 
    UserId     :    0,
    Old        :   [], 
    Current    :   [],
}

const formatMessages            = ({messageHeader, messageVector}) => {
    return (
        <React.Fragment>
            <div>
                <span className={[Style.fw_semibold, Style.fs_6].join(" ")}>
                    {messageHeader}
                </span>
            </div>
            <div>
                {messageVector.map((msg, i) => (
                    <React.Fragment key={i}>
                        <div className={Style.my_3}>
                            <span className={[Style.text_body, Style.fs_8, Style.my_3,].join(" ")}>
                                {i + 1} : {msg}<br/>
                            </span>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </React.Fragment>
    );
};

const EditBtn                   = React.memo(({  Action }) => {
    const handleEditClick = async () => {
        // If the button is rendered, the data for that row exists.
        // Just call the action.
        if (Action) {
            Action();
        }
    };
    useEffect(() => {}, [Action]);
    return (
        <div onClick={handleEditClick} className={[Style.icon, Style.clickable, Style.shadow_sm, Style.p_1, Style.text_center].join(" ")}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"className={[Style.small_ico_generic].join(" ")}>
                <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
            </svg>
        </div>
    );    
});
const BindUserRowEdit           = ({ UserId, UserList, Remove }) => {

    useEffect(() => {
    }, [UserId, UserList, Remove]);
    const currentUser = UserList?.find((u) => u.UserId === UserId);

    return(
        <React.Fragment>
            <div className={[Style.row, Style.py_2].join(" ")}>
                <div className={[Style.col, Style.d_flex, Style.justify_content_center, Style.align_items_center].join(" ")}>
                    {currentUser ? (
                        <div key={currentUser.UserId}>
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {currentUser.FirstName} {currentUser.LastName} ({currentUser.Email})
                            </span>
                        </div>
                    ) : (
                        <span className={Style.fs_8}>
                            <SpinnerSmall/>
                        </span> 
                    )}
                    <div className={[Style.col, Style.d_flex, Style.justify_content_end, Style.align_items_center].join(" ")}>
                        <div
                            onClick={() => {
                                Remove(UserId);
                            }}
                            className={[Style.icon, Style.clickable, Style.p_1].join(" ")}
                        >
                            <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[Style.small_ico_generic].join(" ")}>
                                <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );

};
const BindUserListEdit          = ({ UserData, UserList, Remove }) => {
    useEffect(() => {
    }, [UserData, Remove]);

    useEffect(() => {
    }, [UserList]);

    return(
        <React.Fragment>
            {UserData?.Current?.length > 0 && (
                <div>
                    <div className={Style.py_2}>
                        <span className={[Style.fs_8, Style.text_body, Style.text_decoration_underline].join(" ")}>
                            {GetBusinessLabel("BindPageLabel3")}{":"}
                        </span>
                    </div>
                    {UserData?.Current?.map((d) => {
                        return(<BindUserRowEdit 
                                    UserId={d} 
                                    UserList={UserList} 
                                    Remove={Remove}
                                />)
                        }
                    )}
                </div>
            )}
        </React.Fragment>
    );

};
const BindUserEdit              = ({...setProps}) => {
    const {
        HideSideContent,
        ShowModal,
        HideModal,
        UserData,
        UserList,
        ReFetchUserList 
    }                                                            = setProps;
    const [ isLoading,       setIsLoading]                       = useState(true);   // Loading fetch control
    const [ userObj,         setUserObj]                         = useState(blank_user_obj);   // User Object
    const { showToastMessage            }                        = useToastMessage();   // Toast message display
    const [message,          setMessage]                         = useState({display: false, content:""});
    const [inSameDepartment, setInSameDepartment]                = useState([]);
    const [userList,         setUserList]                        = useState([]);

    const handleSave        = async () => {
        setIsLoading(true);
        let payload = await updateUserBind(userObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                if (userObj.UserId === 0) {
                    setUserObj(prev => {
                        return({
                            ...prev,
                            NeedSave: false,
                            UserId : payload.Response.Content.UserId,
                            Old: [...prev.Current],
                        });
                    });
                }
                else {
                    setUserObj(prev => {
                        return({
                            ...prev,
                            NeedSave: false,
                            Old: [...prev.Current],
                        });
                    });
                }
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const saveAction        = async () => {
        let messages = [];
        if (messages.length > 0) {
            ShowModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await handleSave();
            await ReFetchUserList();
        }
    };
    const handleSelect      = (e) => {
        setUserObj(prev => {
            if (!prev) return prev;

            const currentIds = prev.Current;
            const alreadyExists = currentIds.includes(e);

            if (alreadyExists) {
                handleMessageDisplay(GetSystemLabel("WarningListAlreadyExists"));
            }

            return {
                ...prev,
                NeedSave: true,
                Current: alreadyExists
                    ? currentIds
                    : [...currentIds, e]    
            };
        });
    };
    const handleRemove      = (e) => {
        setUserObj(prev => {
            const updatedItems = prev.Current.filter((d) => d !== e);
            return {
                ...prev,
                NeedSave: true,
                Current: updatedItems,
            };
        });        
    };

    const handleMessageDisplay = async (msg) => {
        setMessage({
            display: true,
            content: msg,
        });

        await sleep(2000);

        // trigger fade-out only
        setMessage(prev => ({
            ...prev,
            display: false,
        }));

        // wait for animation duration (1.5s)
        await sleep(1500);

        // clear content
        setMessage({
            display: false,
            content: "",
        });
    };

    useEffect(() => {
        const fetchData             = async (user_id) => {
            try {
                let payload = await getUserBindByID(user_id);
                if (payload) {
                    if (payload?.Status?.Code === 0) {
                        if (payload?.Response?.Content) {
                            setUserObj(prev => {
                                return ({
                                    ...prev,
                                    NeedSave: false,
                                    UserId: payload.Response.Content.UserId,
                                    Old: [...payload.Response.Content.RelatedIds],
                                    Current: [...payload.Response.Content.RelatedIds],
                                });
                            });
                            setIsLoading(false);
                        }
                    }
                    else {
                        ShowModal(<ModalContent Message={payload.Status.Message}/>);
                        setIsLoading(false);
                    }
                }
            } 
            catch (error) {
                setUserObj(blank_user_obj);
                setIsLoading(false);
            }
        };
        const fetchDataDepartment   = async (user_id) => {
            try {
                let payload = await getUserInDepartmentList(user_id);
                if (payload) {
                    if (payload?.Status?.Code === 0) {
                        if (payload?.Response?.Content) {
                            setInSameDepartment(
                                payload.Response.Content.filter(user => user.UserId !== UserData.UserId)
                            );
                            setIsLoading(false);
                        }
                    }
                    else {
                        ShowModal(<ModalContent Message={payload.Status.Message}/>);
                        setIsLoading(false);
                    }
                }
            } 
            catch (error) {
                setUserObj(blank_user_obj);
                setIsLoading(false);
            }
        };        
        if (UserList) {
            if (UserData?.UserId && UserData.UserId !== 0) {
                setUserList(
                    UserList.filter(user => user.UserId !== UserData.UserId)
                );
                fetchDataDepartment(UserData);
                fetchData(UserData);
            } 
            else {
                setUserList(UserList);
                setUserObj(blank_user_obj);
                setIsLoading(false);
            }
        }
    }, [UserData, UserList]);

    useEffect(() => {
    }, [message]);

    return(
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <div className={[Style.px_3].join(" ")}>
                    <NeedSaveBlock Boolean={userObj?.NeedSave}/>
                    {/* Save Action */}                            
                    <div className={[Style.row, Style.my_3].join(" ")}>
                        <div className={[Style.col_lg_2].join(" ")}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.success_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.fs_8,
                                                Style.text_body,
                                                Style.py_3,
                                                Style.px_5,
                                                Style.pop_item_animation].join(" ")}                                    
                                    onClick={() => {saveAction();}}
                            >
                                <span className={[Style.fs_8, Style.text_ibody].join(" ")}>
                                    {GetSystemLabel("Save")}
                                </span>                                
                            </div>
                        </div>
                    </div>  

                    <div className={[Style.row, Style.my_3].join(" ")}>
                        <div className={[Style.col_lg_4, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetBusinessLabel("BindPageLabel0")}
                            </span>
                        </div>
                    </div>

                    {/* Message Display */}
                    <div className={[Style.row, Style.my_3].join(" ")}>
                        <div className={[Style.col_lg_4, Style.d_flex, Style.align_items_center].join(" ")}></div>
                        <div className={[Style.col_lg_8, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8, message.display ? Style.text_animation_fadein : Style.text_animation_fadeout].join(" ")}>
                                {message.content}
                            </span>
                        </div>
                    </div>     

                    {/* All SameDepartment */}
                    <div className={[Style.row, Style.my_3].join(" ")}>
                        <div className={[Style.col_lg_4, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetBusinessLabel("BindPageLabel1")}
                            </span>
                        </div>
                        <div className={[Style.col_lg_8, Style.d_flex, Style.align_items_center].join(" ")}>
                            <SearchableDropdownList    
                                placeholder={GetBusinessLabel("FieldSelectUser")}
                                listOfItems={
                                        inSameDepartment?.map((d) => ({ value: d.UserId, label: `${d.FirstName} ${d.LastName} : ${d.Email}`}))
                                }
                                style={{ width: "100%" }}  
                                className={Style.antd_custom_select}                               
                                popupClassName={Style.antd_custom_select}                              
                                onChange={(event) => {handleSelect(event);}}
                            />
                        </div>
                    </div>  
                    
                    <div className={[Style.py_3].join(" ")}/>

                    {/* All Users */}
                    <div className={[Style.row, Style.my_3].join(" ")}>
                        <div className={[Style.col_lg_4, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetBusinessLabel("BindPageLabel2")}
                            </span>
                        </div>
                        <div className={[Style.col_lg_8, Style.d_flex, Style.align_items_center].join(" ")}>
                            <SearchableDropdownList    
                                placeholder={GetBusinessLabel("FieldSelectUser")}
                                listOfItems={
                                        userList?.map((d) => ({ value: d.UserId, label: `${d.FirstName} ${d.LastName} : ${d.Email}`}))
                                }
                                style={{ width: "100%" }}  
                                className={Style.antd_custom_select}                               
                                popupClassName={Style.antd_custom_select}                              
                                onChange={(event) => {handleSelect(event);}}
                            />
                        </div>
                    </div>  
                    
                    <div className={[Style.py_3].join(" ")}/>            
                    
                    <BindUserListEdit UserData={userObj} UserList={userList} Remove={handleRemove}/>                        
                </div>
            </React.Fragment>
        
    );

};
const BindContent               = ({...setProps}) => {
    const { ContentType, 
            ShowModal,
            HideModal,
            ShowSideContent,
            HideSideContent,
            StatusList,
            SearchStatus,
            SetSearchStatus,
    }                                            = setProps;
    // Mount State    
    const [isReady, setIsReady]                  = useState(false);     
    const [ access, setAccess]                   = useState(false);
    // Loading State    
    const [ isLoading,  setIsLoading]            = useState(true);   // Loading fetch control
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [rowUser,     setRowUser]              = useState([]);      
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    
    const fetchUserList             = async () => {
        try {
            let payload = await getUserList(SearchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowData(payload.Response.Content);
                    setIsLoading(false);
                }
                else {
                    ShowModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                ShowModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    const fetchUserNotFilteredList  = async () => {
        try {
            const tmp = {
                ...SearchStatus,
                DynamicIds: null
            };

            let payload = await getUserList(tmp);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowUser(payload.Response.Content);
                    setIsLoading(false);
                }
                else {
                    ShowModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                ShowModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };    
    const EditItem = useCallback((data) => {
        if (rowUser?.length === 0) {
            ShowModal(<ModalContent Message={GetSystemLabel("DependenciesLoading")}/>);
            return;
        }        
        let copy = structuredClone(blank_user_obj);

        copy.UserId = data.UserId;

        ShowSideContent({
            component: BindUserEdit,
            props: {
                HideSideContent: HideSideContent,
                ShowModal: ShowModal,
                HideModal: HideModal,
                UserData: copy,
                UserList: rowUser,
                ReFetchUserList: fetchUserList,
            },
            overlay: true,
        });        
    }, [rowUser, ShowSideContent, HideSideContent, ShowModal, HideModal]);

    const columnDefs                = useMemo(() => [
        {
            headerName: GetBusinessLabel("TableHeaderPersonData"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, headerName: GetSystemLabel("Edit"),                     
                    field: GetSystemLabel("Edit")                     ,
                    cellRenderer: (params) => (
                        <EditBtn 
                            DependencyList={rowData}
                            Action={() => EditItem(params.data)} 
                        />
                    ), 
                    cellClass: [Style.table_text_center].join(" "), 
                    headerClass: Style.table_header_center, 
                    flex: 0,
                },                
                { hide: false,lockVisible: true,                           headerName: GetSystemLabel("Name"),                       field: "FirstName"                  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("LastName"),                  field: "LastName"                   ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("Email"),                      field: "Email"                      ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                
                { hide: false,lockVisible: true, columnGroupShow: 'open',  headerName: GetBusinessLabel("HiringDate"),        field: "HiredDate"                  ,cellRenderer: DisplayGridDatetime ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                       
                {   hide: false,lockVisible: true,
                    columnGroupShow: 'open',  
                    headerName: GetSystemLabel("Profile"),             
                    field: "ProfileName",
                    cellRenderer: (params) => (
                        <LabelModule
                            value={params?.data?.ProfileName} 
                        />
                    ),                     
                    filter: false , 
                    flex: 0, 
                    cellClass: [Style.table_text_left].join(" ")
                },
                { hide: false,lockVisible: true, headerName: GetBusinessLabel("Department"),       field: "DepartmentName"             ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                
                {   hide: false,lockVisible: true,
                    columnGroupShow: 'open', 
                    headerName: GetSystemLabel("History"),
                    width: 100,
                    wrapText: true,
                    autoHeight: true,
                    headerClass: Style.table_header_center, 
                    field: "History",
                    cellRenderer: (params) => (
                        <IconHistory
                            Boolean={params?.data?.History === 1? true:false} 
                        />
                    ),
                    cellClass: [Style.table_text_center].join(" ")
                }  
            ]
        },    
        {
            headerName: GetSystemLabel("Relationships"),
            marryChildren: true,
            children: [
                {   hide: false,lockVisible: true,
                    headerName: GetBusinessLabel("Mentees"),
                    field: "MenteeMetaData",
                    width: 400,
                    wrapText: true,
                    autoHeight: true,
                    cellStyle: { whiteSpace: "pre-line" },
                    filter: true , 
                    flex: 0,
                },    
                {   hide: false,lockVisible: true,
                    columnGroupShow: 'open',
                    headerName: GetBusinessLabel("Mentors"),                 
                    field: "MentorMetaData",
                    width: 400,
                    wrapText: true,
                    autoHeight: true,
                    cellStyle: { whiteSpace: "pre-line" },
                    filter: true , 
                    flex: 0,
                },
            ]
        },                   
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Identifier"),              field: "UserId"                     ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,                    
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Status"),                     field: `StatusName${GetAppLang()}`  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedBy"),                 field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedBy"),             field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedDate"),            field: "CreatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedDate"),        field: "UpdatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                
            ]
        },           
    ].filter(Boolean), [rowData, EditItem]);
    
    const gridContext               = useMemo(() => ({
        isLoading,
        rowData,
        setIsLoading,
        EditItem: EditItem,
    }), [rowData]);

    useEffect(() => {
        if (!isReady) {
            if (ValidateBusinessRules("B")) {
                setAccess(true);
                setIsReady(true);
                fetchUserList();
                fetchUserNotFilteredList();
            }
            else {
                setAccess(false);
                setIsReady(true);
            }
        }
    }, [ContentType, isReady]);

    return (
        access ? 
        <React.Fragment>
            <div>
                <p className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("HeaderPageBind")}
                </p>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.pt_1, Style.pb_4].join(" ")}>
                    {StatusList ? 
                        <StatusFilter
                            Main={{
                                keyAttribute: `StatusId`,
                                keyAttributeName: `StatusName${GetAppLang()}`,
                                list: StatusList, 
                            }}
                            Manager={{
                                keyAttribute: `StatusIds`,
                                state: SearchStatus,
                                setState: SetSearchStatus,
                            }}
                            Action={fetchUserList}
                        />
                    :
                        <SpinnerSmall/>
                    }
                </div>                
            </div>
            {isLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={rowData}
                                searchText={searchText}
                                setSearchText={setSearchText}
                                gridContext={gridContext}
                            />
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
        :
        undefined
    );
};

export const BindUsersPage      = () => {
    const [ contentType,    setContentType          ]       = useState(1);
    const [ mount,          setMount                ]       = useState(false);
    const [ statusList,     setStatusList           ]       = useState(null);
    const { showSideContent, hideSideContent        }       = useSideContent();    
    const { showModal, hideModal                    }       = useModal();
    const { showLoader, hideLoader                  }       = useLoader();
    const [ access,     setAccess                   ]       = useState(false);
    const [searchStatus, setSearchStatus            ]       = useState({StatusIds: [], DynamicIds: [1]});    

    const fetchStatusList = async () => {
        try {
            let data = await getSystemStatusList({type: 1});
            if (data) {
                setStatusList(data);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if(!mount) {
            if(ValidateBusinessRules("B")) {
                setAccess(true);
                setMount(true);
                fetchStatusList();
            }
            setMount(true);
        }
    }, [contentType]);

    return (
        access ? 
            <div className={[Style.m_2, Style.pb_5].join(" ")}>
            {
                contentType === 1? 
                    <React.Fragment>
                        <BindContent 
                            ShowSideContent={showSideContent}
                            HideSideContent={hideSideContent}
                            ShowModal={showModal}
                            HideModal={hideModal}
                            ShowLoader={showLoader}
                            HideLoader={hideLoader}
                            ContentType={contentType}
                            StatusList={statusList}
                            SearchStatus={searchStatus}
                            SetSearchStatus={setSearchStatus}                        
                        />
                    </React.Fragment>
                :         
                    null
            }
                <div className={Style.py_2}/>
            </div>
        :
            <AccessDeniedContent/>
    );
};  